import { useGomakeTheme } from "@/hooks/use-gomake-thme";
import { FONT_FAMILY } from "@/utils/font-family";
import { useMemo } from "react";
import { useTheme } from "@/contexts/theme/useTheme";

const useStyle = () => {
  const { primaryColor, theme } = useGomakeTheme();
  const { currentTheme } = useTheme();
  const isHpClient = currentTheme === "hp-client";

  const classes = useMemo(() => {
    const baseOptionsButtons = {
      "& .MuiButton-startIcon": {
        margin: "0 5px",
      },
      ...FONT_FAMILY.Inter(500, 16),
      borderRadius: "8px",
      height: "40px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textTransform: "capitalize" as "capitalize",
    };

    const optionsButtons = isHpClient
      ? {
          ...baseOptionsButtons,
          backgroundColor: "transparent",
          color: primaryColor(500),
          border: "none",
          "&:hover": {
            backgroundColor: primaryColor(50),
            border: "none",
          },
        }
      : {
          ...baseOptionsButtons,
          backgroundColor: "#FFFFFF",
          color: "#344054",
          border: "1px solid #D0D5DD",
          "&:hover": {
            backgroundColor: "#F0F4FF",
            border: "1px solid #D0D5DD",
          },
        };

    return {
      mainContainer: {
        display: "flex",
        flexDirection: "row" as "row",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 15,
      },
      btnContainer: {
        width: "fit-content",
        height: 40,
        lineHeight: "18px",
      },
      optionsButtons,
      primaryButton: {
        ...FONT_FAMILY.Inter(500, 16),
        borderRadius: "8px",
        height: "40px",
        backgroundColor: primaryColor(500),
        color: "#FFF",
        textTransform: "capitalize",
        "&:hover": {
          backgroundColor: primaryColor(600),
        },
      },
    };
  }, [theme, isHpClient, primaryColor]);
  return {
    classes,
  };
};
export { useStyle };
